import React from "react";
import PropTypes from 'prop-types';
import { Col, Container, Row, Image, Modal } from "react-bootstrap";
import { Card, IconButton, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import NumberFormat from "react-number-format";
import './LoanProtectionQuoteCard.scss';

const useStyles = makeStyles((theme) => ({
    header: {
        color: `${theme.palette.primary.main} !important`,
    },
}));

export default function LoanProtectionQuoteCard(props) {
    const classes = useStyles();
    const modalInfo = props.modalQuoteInfo;
    const hasRating =
        modalInfo.ratingAMBest ||
        modalInfo.ratingSP ||
        modalInfo.ratingMoodys ||
        modalInfo.ratingFitch ||
        modalInfo.ratingComdex;

    return (
        <Modal {...props} className='quote-info-modal' aria-labelledby="quote-info-modal" size="lg">
            <Modal.Body className="show-grid">
                <Container>
                    <Row className="float-right">
                        <IconButton className='p-0' aria-label="close" onClick={props.onHide}>
                            <CloseIcon />
                        </IconButton>
                    </Row>
                    <Row>
                        <Image className='image-property' src={modalInfo.logoUrl} alt={'Americo Logo'} />
                    </Row>
                    <Row className={`rating ${classes.header}`}>
                        {modalInfo.rating} Rating
                    </Row>
                    <Row className='productName'>
                        {modalInfo.productName}
                    </Row>
                    <Row className='veribage-text'>
                        As low as
                    </Row>
                    <Row>
                        <Col xs="3" md="9">
                            <Stats monthlyRate={modalInfo.monthlyRate} modalInfo={modalInfo}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="product-details-info pl-0">
                            {modalInfo.productDescription}
                        </Col>
                        <Col className='product-information'>
                            Product Information
                            <div className='product-information-elements'>
                                <ul dangerouslySetInnerHTML={{ __html: modalInfo.productInformation }} />
                            </div>
                        </Col>
                    </Row>
                    {hasRating && (
                        <div className="ratings">
                            <Row className='insurance-carrier-text'>
                                Insurance Company Ratings
                            </Row>
                            <Row>
                                <ul className="d-flex rating-cards">
                                    {modalInfo.ratingAMBest && (
                                        <li>
                                            <ProductDetailsRatingCard logo="/logos/ratings/ambest.jpg" rater="AM Best" rating={modalInfo.ratingAMBest} />
                                        </li>
                                    )}
                                    {modalInfo.ratingSP && (
                                        <li>
                                            <ProductDetailsRatingCard logo="/logos/ratings/sp.jpg" rater="S&amp;P Global" rating={modalInfo.ratingSP} />
                                        </li>
                                    )}
                                    {modalInfo.ratingMoodys && (
                                        <li>
                                            <ProductDetailsRatingCard logo="/logos/ratings/moodys.jpg" rater="Moody's" rating={modalInfo.ratingMoodys} />
                                        </li>
                                    )}
                                    {modalInfo.ratingFitch && (
                                        <li>
                                            <ProductDetailsRatingCard logo="/logos/ratings/fitch.jpg" rater="Fitch" rating={modalInfo.ratingFitch} />
                                        </li>
                                    )}
                                    {modalInfo.ratingComdex && (
                                        <li>
                                            <ProductDetailsRatingCard logo="/logos/ratings/comdex.jpg" rater="Comdex" rating={modalInfo.ratingComdex} />
                                        </li>
                                    )}
                                </ul>
                            </Row>
                        </div>
                    )}
                </Container>
            </Modal.Body>
        </Modal>
    );
}
const ProductDetailsRatingCard = (props) => {
    const classes = useStyles();
    return (
        <Card className="rating-card">
            <div className="rating-card-head">
                <img src={props.logo} alt={props.rater} className="img-fluid" />
            </div>
            <p className="rater">{props.rater}</p>
            <p className={`insurance-carrier-rating ${classes.header}`}>{props.rating}</p>
        </Card>
    );
};
const Stats = (props) => {
    const classes = useStyles();
    return (
        <div className="product-details-stats">
            <Row>
                <Col className="pl-0">
                    <p>
                        <NumberFormat
                            className="quote-amount-dollars"
                            value={props.monthlyRate}
                            displayType={'text'}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale={true}
                        />
                        <span className="quote-amount-mo">/mo</span>
                    </p>
                </Col>

                <Col>
                    <p className="stat-title">Typically Takes</p>
                    <p className={`stat-text ${classes.header}`}>{props.modalInfo.underwritingTimeTypical}</p>
                </Col>

                <Col>
                    <p className="stat-title">Medical Exam</p>
                    <p className={`stat-text ${classes.header}`}>{props.modalInfo.requiresMedicalExam}</p>
                </Col>
            </Row>
        </div>
    );
};

LoanProtectionQuoteCard.propTypes = {
    modalInfo: PropTypes.object,
    modalQuoteInfo: PropTypes.object,
    onHide: PropTypes.func,
    logo: PropTypes.string,
    rater: PropTypes.string,
    rating: PropTypes.string,
    monthlyRate: PropTypes.number,
};
ProductDetailsRatingCard.propTypes = {
    logo: PropTypes.string,
    rater: PropTypes.string,
    rating: PropTypes.string,
};
Stats.propTypes = {
    modalInfo: PropTypes.object,
    monthlyRate: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Cards/LoanProtectionQuoteCard.js